import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  IconControl,
  IconRelatorios,
  IconHistorico,
  IconCadastro,
  IconConsultasExternas,
  IconGestao,
  IconInformacoes,
} from '../iconsMenu';

export const menus = [
  {
    id: uuidv4(),
    key: 1,
    icone: <IconControl />,
    icone2: <IconControl active />,
    nome: 'Painel de Controle',
    url: '/painel-de-controle',
    permissoes: ['MenuPainelControle', 'Operador'],
  },
  {
    id: uuidv4(),
    key: 2,
    icone: <IconRelatorios />,
    icone2: <IconRelatorios active />,
    nome: 'Relatórios',
    url: '/relatorios',
    permissoes: ['MenuRelatorio'],
  },
  {
    id: uuidv4(),
    key: 3,
    icone: <IconHistorico />,
    icone2: <IconHistorico active />,
    nome: 'Histórico Solicitação',
    url: '/historico',
    permissoes: ['HistoricoAtendimento'],
  },
  {
    id: uuidv4(),
    key: 4,
    icone: <IconCadastro />,
    icone2: <IconCadastro active />,
    nome: 'Cadastro',
    url: '/cadastro',
    permissoes: [
      'CadastroMatriz',
      'CadastroCliente',
      'CadastroUsuario',
      'CadastroConsulta',
      'CadastroGrupoUsuario',
    ],
  },
  {
    id: uuidv4(),
    key: 5,
    icone: <IconCadastro />,
    icone2: <IconCadastro active />,
    nome: 'Cadastros v2',
    url: null,
    menus: [
      {
        id: uuidv4(),
        nome: 'Usuários',
        url: '/cadastros-v2/usuarios',
        permissoes: ['CadastroUsuario'],
      },
      {
        id: uuidv4(),
        nome: 'Clientes',
        url: '/cadastros-v2/clientes',
        permissoes: ['CadastroCliente'],
      },
      {
        id: uuidv4(),
        nome: 'Grupos de usuário',
        url: '/cadastros-v2/grupos-de-usuario',
        permissoes: ['CadastroGrupoUsuario'],
      },
      {
        id: uuidv4(),
        nome: 'Consultas',
        url: '/cadastros-v2/consultas',
        permissoes: ['CadastroConsulta'],
      },
      {
        id: uuidv4(),
        nome: 'Matrizes',
        url: '/cadastros-v2/matrizes',
        permissoes: ['CadastroMatriz'],
      },
    ],
  },
  {
    id: uuidv4(),
    key: 6,
    icone: <IconConsultasExternas />,
    icone2: <IconConsultasExternas active />,
    nome: 'Consultas Externas',
    url: '/consultas-externas-painel',
    permissoes: ['MenuConsultasExternas', 'OperadorExterno'],
  },
  {
    id: uuidv4(),
    key: 7,
    icone: <IconConsultasExternas />,
    icone2: <IconConsultasExternas active />,
    nome: 'Atendimento Externo',
    url: '/atendimento-externo',
    permissoes: ['MenuAtendimentoExterno', 'OperadorExterno'],
  },
  {
    id: uuidv4(),
    key: 8,
    icone: <IconGestao />,
    icone2: <IconGestao active />,
    nome: 'Gestão',
    url: null,
    menus: [
      {
        id: uuidv4(),
        key: 1,
        icone: null,
        nome: 'Erros de Webhook',
        url: '/gestao/erros-webhook',
        permissoes: ['ControleWebhook'],
      },
      {
        id: uuidv4(),
        key: 2,
        icone: null,
        nome: 'Parâmetros Gerais',
        url: '/parametros-gr',
        permissoes: ['ControleParametrosGerais'],
      },
      {
        id: uuidv4(),
        key: 3,
        icone: null,
        nome: 'Migração',
        url: '/migracao',
        permissoes: ['ControleMigracao'],
      },
      {
        id: uuidv4(),
        key: 4,
        icone: null,
        nome: 'Logs de Integração',
        url: '/gestao/logs-integracao',
        permissoes: ['VisualizarLogsIntegracao'],
      },
      {
        id: uuidv4(),
        key: 5,
        icone: null,
        nome: 'Logs de cadastros',
        url: '/gestao/logs-cadastros',
        permissoes: [
          'VisualizarLogsCadastros',
        ],
      },
    ],
  },
  {
    id: uuidv4(),
    key: 9,
    icone: <IconInformacoes />,
    icone2: <IconInformacoes active />,
    nome: 'Portal Informações',
    url: '/portal-de-informacoes',
    permissoes: ['PortalInformacoes'],
  },
];
